import { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router';
import { requete } from '../../api/client';
import { messageErreur } from '../../api/erreurs';
export function ConfigurationPortail() {
  const client = useQueryClient();
  const [erreur, setErreur] = useState('');
  const [enCours, setEnCours] = useState(false);
  const q = useQuery({
    queryKey: ['portail-public', 'configuration'],
    queryFn: () => requete<{ ouvert: boolean; version: number }>('/portail-public/configuration'),
  });
  return (
    <details>
      <summary>Réception des signalements citoyens</summary>
      <Link to="/citoyen">Consulter le portail citoyen</Link>
      <p>
        Ouvrir la réception rend le nom de votre organisation visible dans la liste des exploitants.
        Cette ouverture permet aussi le dépôt de réclamations générales sans signalement préalable.
        Fermer la réception conserve les dossiers et leur suivi secret.
      </p>
      {q.data && (
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            const d = new FormData(e.currentTarget);
            setErreur('');
            setEnCours(true);
            try {
              await requete('/portail-public/configuration', {
                methode: 'POST',
                corps: { ouvert: !q.data.ouvert, version: q.data.version, motif: d.get('motif') },
              });
              await client.invalidateQueries({ queryKey: ['portail-public'] });
            } catch (err) {
              setErreur(messageErreur(err));
            } finally {
              setEnCours(false);
            }
          }}
        >
          <p>Réception {q.data.ouvert ? 'ouverte' : 'fermée'}</p>
          <label>
            Motif de changement <input name="motif" required minLength={3} maxLength={500} />
          </label>
          <button disabled={enCours}>
            {q.data.ouvert ? 'Fermer la réception' : 'Ouvrir la réception'}
          </button>
        </form>
      )}
      {(erreur || q.error) && <p role="alert">{erreur || messageErreur(q.error)}</p>}
    </details>
  );
}
